import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { logoutApi } from '@/api/modules/auth/logout';

/**
 * 用户信息接口
 */
export interface UserInfo {
  userId: string;
  username: string;
  nickname?: string;
  email: string;
  avatarUrl?: string;
  phone: string;
  /**
   * 客户端id userInfo 接口没有返回，通过登录第二步校验接口获取
   */
  clientId: string;
  /**
   * 权限码列表 userInfo 接口没有返回，通过登录第二步校验接口获取
   */
  permissionCodes?: string[];
  /**
   * 角色信息 userInfo 接口没有返回，通过登录第二步校验接口获取
   */
  roleKeys?: string[];
  /**
   * 角色名称列表 userInfo 接口没有返回，通过登录第二步校验接口获取
   */
  roleNames?: string[];
}

/**
 * 用户状态接口
 */
export interface UserState {
  userInfo: UserInfo | null;
  token: string | null;
  setUserInfo: (info: UserInfo) => void;
  setToken: (token: string) => void;
  clearUser: () => void;
}

/**
 * 用户状态管理 Store
 * 使用 Zustand 创建轻量级状态管理
 * 支持状态持久化到 localStorage
 */
export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      // 初始状态
      userInfo: null,
      token: null,

      // 设置用户信息
      setUserInfo: (info: UserInfo) => {
        set({ userInfo: info });
      },

      // 设置 token
      setToken: (token: string) => {
        set({ token });
      },

      // 清除用户信息（用于退出登录）
      clearUser: () => {
        set({ userInfo: null, token: null });
      },
    }),
    {
      name: 'user-storage', // localStorage 中的 key
      version: 2,
      // 可选：自定义存储方式
      // storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export const getAuthToken = () => useUserStore.getState().token;

export const logout = () => {
  logoutApi();
  useUserStore.getState().clearUser();
};
